import React, { useState } from "react"
import { useSelector } from "react-redux"

import { StoreType } from "client/store"
import {
    PageContent,
    PageMenu,
    PageMenuButton,
    Tab,
} from "client/components"

import Priority from "./priority"
import ReviewMethod from "./reviewMethod"
import SmartCompliance from "./smartCompliance"
import Status from "./status"
import Type from "./type"
import { ContainerStyled, Title } from "../styled"

const PRIORITY = "#priority"
const REVIEW_METHOD = "#reviewMethod"
const SMART_COMPLIANCE = "#smartCompliance"
const STATUS = "#status"
const TYPE = "#type"

const CcRequirementSettings = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const menu = [
        { key: PRIORITY, title: lang.priority },
        { key: REVIEW_METHOD, title: lang.reviewMethod },
        { key: SMART_COMPLIANCE, title: lang.smartCompliance },
        { key: STATUS, title: lang.status },
        { key: TYPE, title: lang.type },
    ]

    const [activeTab, setActiveTab] = useState(PRIORITY)

    return (
        <ContainerStyled>
            <Title>{lang.requirementsSettings}</Title>
            <PageContent>
                <PageMenu>
                    {
                        menu.map((menuRow) => (
                            <PageMenuButton
                                key={menuRow.key}
                                isActive={activeTab === menuRow.key}
                                onClick={() => setActiveTab(menuRow.key)}
                            >
                                {menuRow.title}
                            </PageMenuButton>
                        ))
                    }
                </PageMenu>

                <Tab show={activeTab === PRIORITY}>
                    <Priority />
                </Tab>
                <Tab show={activeTab === REVIEW_METHOD}>
                    <ReviewMethod />
                </Tab>
                <Tab show={activeTab === SMART_COMPLIANCE}>
                    <SmartCompliance />
                </Tab>
                <Tab show={activeTab === STATUS}>
                    <Status />
                </Tab>
                <Tab show={activeTab === TYPE}>
                    <Type />
                </Tab>
            </PageContent>
        </ContainerStyled>
    )
}
export default CcRequirementSettings
